<div class="add-new-comment" *appRequiredRoles="['admin', 'editor', 'reviewer']">
  <h4>Add a Comment</h4>
  <mat-form-field appearance="outline" class="full-width-input">
    <mat-label>Your new comment</mat-label>

    <textarea matInput [formControl]="newCommentControl" placeholder="Type your comment here..." rows="3"></textarea>

    @if (newCommentControl.hasError('required') && newCommentControl.touched) {
      <mat-error>Comment is required and cannot be empty.</mat-error>
    }
  </mat-form-field>
  <button mat-button [disabled]="isDisabledEdit" (click)="addComment()" class="primary-btn">Post Comment</button>
</div>
@if (taskCommentIsLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (taskComments.length === 0) {
  <ul class="comment-list">
    <li class="no-comments">Be the first to comment!</li>
  </ul>
} @else {
  <ul class="comment-list">
    @for (editComment of taskComments; track editComment.comment.comment_id) {
      <li class="comment-item" [class.my-comment]="editComment.isSelf">
        <div class="header">
          <span class="name">
            {{ editComment.comment.created_by.name | shortId }}
            @if (editComment.isSelf) {
              <span class="badge">YOU</span>
            }
            <span class="type"> ({{ editComment.comment.created_by.type | titlecase }})</span>
          </span>
          <div class="meta">
            <span class="date">{{ editComment.comment.created_at | date: 'YYYY MMM d, h:mm a' }}</span>
            @if (editComment.comment.created_at !== editComment.comment.updated_at) {
              <span class="edited"> (edited)</span>
            }
          </div>
        </div>

        @if (!editComment.isEditing) {
          <div class="content">
            <p>{{ editComment.comment.comment }}</p>

            <div
              class="actions"
              *appRequiredRoles="[
                { role: 'admin', status: ['DRAFTING', 'IN_REVIEW', 'APPROVED'] },
                { role: 'reviewer', status: ['DRAFTING', 'IN_REVIEW', 'APPROVED'] },
                { role: 'editor', status: ['DRAFTING', 'IN_REVIEW', 'APPROVED'] }
              ]">
              @if (editComment.canBeEdited) {
                <button
                  (click)="toggleEditMode(editComment, true)"
                  mat-icon-button
                  [color]="'primary'"
                  [disabled]="isDisabledEdit"
                  [matTooltip]="'Edit comment'">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (editComment.canBeDeleted) {
                <button
                  (click)="deleteComment(editComment)"
                  mat-icon-button
                  [disabled]="isDisabledEdit"
                  [color]="'error'"
                  [matTooltip]="'Delete comment'">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        } @else {
          <div class="edit-mode">
            <textarea [disabled]="isDisabledEdit" [(ngModel)]="editComment.comment.comment"></textarea>
            <div class="actions">
              <button
                (click)="toggleEditMode(editComment, false)"
                mat-icon-button
                [disabled]="isDisabledEdit"
                [color]="'primary'"
                [matTooltip]="'Revert'">
                <mat-icon>edit_off</mat-icon>
              </button>
              <button
                (click)="updateComment(editComment)"
                mat-icon-button
                [disabled]="isDisabledEdit"
                [color]="'error'"
                [matTooltip]="'Update comment'">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
        }
        @if (editComment.isPending) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </li>
    }
  </ul>
}
